import { localStorageInstance } from '@gem/modules/storage';

const PREFERRED_DISCOVER_DESTINATION_KEY_STORAGE_KEY = 'preferred-discover-destination-key';

function getStorageKey(email: string): string {
  return `${PREFERRED_DISCOVER_DESTINATION_KEY_STORAGE_KEY}-${email}`;
}

export function set(email: string, destinationKey: string): void {
  const storageKey = getStorageKey(email);

  localStorageInstance.setItem(storageKey, destinationKey);
}

export function get(email: string): string {
  return localStorageInstance.getItem(getStorageKey(email)) || '';
}

export function remove(email: string): void {
  localStorageInstance.removeItem(getStorageKey(email));
}
